let lastDocHeight = -1;

export default function() {
    if ( 'updateHeight' in window.parent && typeof window.parent.updateHeight === "function" ) {
        setTimeout( function() {
            let setHeight = (document.querySelector( ".container" ) || document.body).scrollHeight;
            if ( setHeight !== lastDocHeight ) {
                lastDocHeight = setHeight;
                window.parent.updateHeight( setHeight );
            }
            console.log('setHeight: ' + setHeight);
        },1500);

    }
}